import { v4 as uuid } from "uuid";
import { useContext, useEffect, useState } from "react";
import Card from "../../../components/card/card";
import { useFormContext } from "react-hook-form";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import { createUserPatient, updateUserPatient } from "../../../../../actions";
import { useAppDispatch } from "../../../../../store/hooks";
import { addNotification } from "../../../../../store/slices/ui-slice";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Box } from "@mui/material";
import { loadAddressOptions } from "../../../../../utils/common-utils";
import TextInputFormField from "../../../../../components/form-fields/text-input-field/text-input-form-field";
import AsyncPaginateFormField from "../../../../../components/form-fields/asyncpaginate-field/async-paginate-field";

const AddClient = () => {
  const {
    state: { activeStep, user, updateUserMeta },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const { control, handleSubmit, setValue, watch } = useFormContext();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const onAddClient = async (values: any) => {
    const { address, firstName, lastName, email, mobile } = values;
    setLoading(true);

    try {
      if (updateUserMeta && address?.value !== user?.address) {
        const payload = {
          ...user,
          address: address?.value || "",
          email,
          firstName,
          lastName,
          mobile: mobile || user?.phone,
        };
        const userResponse = await updateUserPatient(payload);
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_CLIENT_ACCOUNT,
          payload: userResponse?.data?.data,
        });
      } else if (!updateUserMeta) {
        const payload = {
          address: address?.value || "",
          email,
          firstName,
          lastName,
          mobile: mobile || user?.phone,
          numberOfPets: 0,
        };

        const userResponse = await createUserPatient(payload);
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_CLIENT_ACCOUNT,
          payload: userResponse?.data?.data,
        });
      } else {
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_CLIENT_ACCOUNT,
          payload: user,
        });
      }
      userDispatcher({
        type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
        payload: activeStep + 1,
      });
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message || "An unexpected error occurred.",
        })
      );
    } finally {
      setLoading(false);
    }
  };
  const fullAddress = `${user?.address}, ${user?.city}, ${user?.state}`;

  useEffect(() => {
    if (user && updateUserMeta) {
      setValue("firstName", user.first_name || "");
      setValue("lastName", user.last_name || "");
      setValue("address", {
        label: fullAddress || "",
        value: fullAddress || "",
      });
    }
  }, [user, setValue, updateUserMeta, fullAddress]);
  return (
    <Card
      title={updateUserMeta ? "Update Personal details" : "Personal details"}
      // description="We couldn't retrieve your information against your email account or phone number. Please enter your personal information below to continue with the appointment."
      btnTitle={
        <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
          <span>Go to personal detail form</span>
          <ArrowOutwardIcon />
        </div>
      }
      // onHandleClick={handleSubmit(onAddClient)}
      onHandleClick={() => {
        window.open("https://www.cognitoforms.com/ChasingTailsMobileVeterinaryServices/ChasingTailsNewClientForm", "_blank");
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: 1,
        });
      }}
      progress={activeStep * 5}
      // disabledConfirmBtn={
      //   loading ||
      //   !watch("firstName") ||
      //   !watch("lastName") ||
      //   !watch("address")
      // }
      isLoadingConfirmBtn={loading}
      showBackButton={updateUserMeta}
      handleBack={() => {
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
          payload: 9,
        });
        userDispatcher({
          type: USER_APPOINTMENT_ACTIONS.UPDATE_USER_META,
          payload: false,
        });
      }}
    >
      <div className="form">
        {/* <Box sx={{ display: "flex", flexDirection: "row", columnGap: "10px" }}>
          <TextInputFormField
            name="firstName"
            control={control}
            label="First Name"
            placeholder="Enter here"
            defaultValue={user?.first_name || ""}
            disabled={updateUserMeta}
          />
          <TextInputFormField
            name="lastName"
            control={control}
            label="Last Name"
            placeholder="Enter here"
            disabled={updateUserMeta}
            defaultValue={user?.last_name || ""}
          />
        </Box>
        <AsyncPaginateFormField
          id="address"
          name="address"
          label="Address"
          control={control}
          loadOptions={loadAddressOptions}
          placeholder="Type your address..."
          isClearable
        /> */}
        We couldn't retrieve your information against your email account or
        phone number. Please click on button below to input your personal
        information below and our team would get back to you shortly.
      </div>
    </Card>
  );
};

export default AddClient;
